import moment from 'moment';
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '../common';
import { getDisplayNickname, getHandlerRequestMember, getMemberByUserID, handlerLiveMember } from '../members';
import { connect } from '../redux';
import { Icon } from '../ui';
import { toggleHandlerEnquries } from './actions';
import SideBarHeader from './SideBarHeader';
const HandlerRequest = React.memo(({ handlerMember, isMonitoring, hideMember, }) => {
    const dispatch = useDispatch();
    // const hideContent = () => dispatch(toggleHideMember(!hideMember));
    // @ts-ignore
    const handlerClose = () => dispatch(toggleHandlerEnquries(false));
    const renderHead = useMemo(() => (React.createElement(SideBarHeader, { name: "handler", isMonitoring: isMonitoring, showBody: !hideMember, hideContent: undefined, handlerClose: handlerClose })), [isMonitoring, hideMember]);
    // Sort handlerMember to have pinned member at the top
    return (React.createElement("div", { className: 'handler_request' },
        renderHead,
        React.createElement("div", { className: "handler_wrap" }, handlerMember.map((member, index) => member && React.createElement(MebmerItem, { key: member, memberId: member, index: index })))));
});
function _mapStateToProps(state) {
    const handlerMember = getHandlerRequestMember(state, false);
    return {
        handlerMember,
    };
}
export default connect(_mapStateToProps)(HandlerRequest);
export const MebmerItem = React.memo(({ memberId, index }) => {
    const dispatch = useDispatch();
    const member = useSelector((state) => getMemberByUserID(state, memberId));
    if (!member)
        return null;
    return (React.createElement("div", { className: "box", key: member.user_uuid, style: {
            backgroundColor: `${member.pinned ? `#F9FBFF` : '#F8F8F8'}`,
            border: `${member.pinned ? `2px solid #8bacff` : ''}`,
        } },
        React.createElement("div", { className: "member_rasie_hand_wrap", style: { marginLeft: 0, width: `200px` } },
            member.pinned ? React.createElement(Icon, { icon: "raise_hand", color: "#8CACFF", size: 24 }) : React.createElement("p", { className: "member_index" }, index + 1),
            React.createElement("div", null,
                React.createElement("div", { className: "headline" }, getDisplayNickname(member.nickname, member.role) || '-'),
                React.createElement("div", { className: member.pinned ? 'hands-up accept' : member.hands_up_time ? 'hands-up time' : 'hands-up' }, member.pinned
                    ? '현재 손들기 상태입니다'
                    : member.hands_up_time
                        ? moment(member.hands_up_time).format('HH:mm')
                        : '요청을 취소함'))),
        React.createElement("div", { className: "btn-container" },
            !member.pinned && (React.createElement(Button, { onClick: async () => {
                    dispatch(handlerLiveMember(member.user_uuid, true));
                }, handlerIcon: "accept" })),
            React.createElement(Button, { onClick: async () => {
                    dispatch(handlerLiveMember(member.user_uuid, false));
                }, handlerIcon: "reject" }))));
});
